import {createContainer} from 'redux-box';
import state from './state';
import actions from './actions';
import mutations from './mutations';
import sagas from './sagas';
import {watcherSagas} from './sagas';

export const module = {
    name: 'user',
    actions,
    state,
    mutations,
    sagas: [...Object.values(sagas), ...watcherSagas],
    sagas
};

export const container = createContainer(module);
export default container;
